import { Modal } from 'components/common/Modal/Modal';
import { useCallback, useState } from 'react';
import i18n from 'i18n';
import { DefaultRtbCampaignManager } from 'core/rtbCampaign/RtbCampaignManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import styles from './adminBidPriceModal.module.scss';

export type BidPriceModalProps = {
  campaign: {
    id: number;
    bidPrice: number;
    adminBidPrice?: number;
  };
  onFinish: () => void;
  onClose: () => void;
};

const campaignManager = new DefaultRtbCampaignManager();

const MIN_ADMIN_BID_PRICE = 0.01;

export const AdminBidPriceModal: React.FC<BidPriceModalProps> = ({
  campaign,
  onFinish,
  onClose
}) => {
  const [value, setValue] = useState<number | undefined>(
    campaign.adminBidPrice || campaign.bidPrice
  );
  const { loading, callAPIs } = useCallAPI();

  const onConfirm = useCallback(() => {
    callAPIs(
      [() => campaignManager.updateCampaignAdminBidPrice(campaign.id, value)],
      onFinish
    );
  }, [value, campaign.id, onFinish, callAPIs]);

  const onInputValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value === '') {
        return setValue(undefined);
      }
      setValue(+e.target.value);
    },
    []
  );

  return (
    <>
      {loading && <LoadingIndicator />}
      <Modal
        className={styles.adminBidPriceModal}
        title={i18n.t('adminBidPriceModal.titles.manageAdminBidPrice', {
          id: campaign.id
        })}
        primaryButton={{
          title: i18n.t('common.buttons.save'),
          callback: onConfirm,
          disabled: value !== undefined && value < MIN_ADMIN_BID_PRICE
        }}
        secondaryButton={{
          title: i18n.t('common.buttons.cancel'),
          callback: onClose
        }}
        dismiss={onClose}
        centerButtons
      >
        <div className={styles.inputContainer}>
          <label htmlFor={`modify-admin-bid-price-${campaign.id}`}>
            {i18n.t('adminBidPrice.labels.modifyAdminBidPrice')}
          </label>
          <input
            id={`modify-admin-bid-price-${campaign.id}`}
            value={value}
            onChange={onInputValueChange}
            type='number'
            min={MIN_ADMIN_BID_PRICE}
          />
        </div>
      </Modal>
    </>
  );
};
